import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import VueGtag from "vue-gtag";


Vue.config.productionTip = false;

Vue.use(VueGtag, {
    config: {id: "UA-168235217-1"}
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount("#app");
